import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/pizzaLogo.png';
import '../styles/Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSun, faMoon, faTimes } from '@fortawesome/free-solid-svg-icons';

function Navbar() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  // Close mobile menu when window is resized to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const toggleTheme = () => setDarkMode(prev => !prev);
  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className={`navbar ${darkMode ? 'dark' : 'light'}`}>
        <div className="navbar-container">
          <div className="leftSide">
            <Link to="/" className="logo-link" onClick={closeMenu}>
              <img src={logo} alt="Pizza Logo" className="navbar-logo" />
            </Link>
          </div>

          <div className="rightSide">
            <div className="desktopLinks">
              <Link to="/">Home</Link>
              <Link to="/menu">Menu</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
            </div>

            <button
              onClick={toggleTheme}
              aria-label="Toggle Theme"
              aria-pressed={darkMode}
              className="theme-toggle"
            >
              <FontAwesomeIcon icon={darkMode ? faSun : faMoon} />
            </button>

            <button
              onClick={toggleMenu}
              aria-label="Toggle Menu"
              aria-expanded={menuOpen}
              className="mobile-menu-toggle"
            >
              <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu overlay */}
      <div className={`mobile-menu-overlay ${menuOpen ? 'open' : ''}`} onClick={closeMenu} />
      
      {/* Mobile menu */}
      <div className={`mobileMenu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/menu" onClick={closeMenu}>Menu</Link>
          <Link to="/about" onClick={closeMenu}>About</Link>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
        </div>
      </div>
    </>
  );
}

export default Navbar;